import React from "react";
import { BiEnvelope } from "react-icons/bi";
import { GrLocation } from "react-icons/gr";
import { BsTelephone } from "react-icons/bs";
import { FaLinkedin, FaTwitter, FaGithub } from "react-icons/fa";
import { IoEarthSharp } from "react-icons/io5";
import { Input } from "@material-tailwind/react";
import { Textarea } from "@material-tailwind/react";
import { Button } from "@material-tailwind/react";

import './Contact.css'

const Contact = () => {
    return (
        <section className='contact-section bg-accent'>
            <div className='rounded-3xl bg-white'>
                <div className='flex lg:justify-between justify-center lg:flex-row flex-col-reverse'>

                    <div className="w-72 lg:relative static pt-10 bg-primary contact-us-info-container text-slate-800 px-7">
                        <h5 className="text-xl py-2">Get in touch</h5>
                        <small>We love to heare from you. Our friendly team is always here to chat!</small>
                        <div className="flex items-center pt-4">
                            <BiEnvelope />
                            <h4 className="ml-2">Chat to us</h4>
                        </div>
                        <div className="ml-7">
                            <small>Our friendly team is here to help.</small>
                            <small className="block">megamindedmanik@gmail.com</small>
                        </div>

                        <div className="flex items-center pt-4">
                            <GrLocation />
                            <h4 className="ml-2">Office</h4>
                        </div>
                        <div className="ml-7">
                            <small>Come to say hello at our office HQ</small>
                            <small className="block">408 Almaden Boulevard</small>
                            <small className="block">San Jose, CA 95113</small>
                        </div>

                        <div className="flex items-center pt-4">
                            <BsTelephone />
                            <h4 className="ml-2">Phone</h4>
                        </div>
                        <small className="ml-7">Mon - Fri from 8am to 5pm</small>

                        <div className="lg:absolute static pt-7 pb-4 left-14 flex justify-center lg:gap-4 bottom-2">
                            <a href="https://github.com/MagicManik" target="_blank" rel="noreferrer"><FaGithub className="text-3xl lg:mx-0 mx-3" /></a>
                            <a href="https://www.linkedin.com/in/manikislammahi/" target="_blank" rel="noreferrer"><FaLinkedin className="text-3xl lg:mx-0 mx-3" /></a>
                            <a href="https://twitter.com/ManikIslamMahi" target="_blank" rel="noreferrer"><FaTwitter className="text-3xl lg:mx-0 mx-3" /></a>
                            <a href="https://magicmanik.netlify.app/" target="_blank" rel="noreferrer"><IoEarthSharp className="text-3xl lg:mx-0 mx-3" /></a>
                        </div>
                    </div>
                    <div className='lg:py-16 py-7 block mx-auto contact-input-container'>
                        <div className="lg:px-0 px-4">
                            <h5 className="text-2xl font-semibold text-black">Send us a Message</h5>
                            <p className="pt-3 pb-4 block">You can reach us anytime via <span className=" font-semibold">megamindedmanik@gmail.com</span></p>
                        </div>

                        <div className="flex flex-col lg:px-0 px-4 pt-4">
                            <div className="mb-7">
                                <Input label="Your Name" type="text" />
                            </div>

                            <div className="mb-7">
                                <Input variant="outlined" label="Email" type="email" />
                            </div>

                            <div className="mb-6">
                                <Textarea label="Message" rows={3}></Textarea>
                            </div>

                            <Button className="btn bg-[#ffdf80] hover:bg-[#ffd34f] border-0 text-[#030303] shadow-none hover:shadow-none tracking-widest">SEND MESSAGE</Button>
                        </div>
                    </div>
                </div>
            </div>


        </section>
    );
};

export default Contact;